import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import {
  buildRootSizeStyles,
  buildSizeObj,
  buildSizeStyles,
  DS_SIZE_MAP,
  matchSize,
  matchRootSize,
} from 'Components/ComponentLibrary/DesignSystem/sizes';

const SIZES = [
  buildSizeObj(DS_SIZE_MAP.md, {
    rootWidth: 36,
    rootHeight: 36,
    iconWidth: 18,
    iconHeight: 18,
  }),
  buildSizeObj(DS_SIZE_MAP.lg, {
    rootWidth: 64,
    rootHeight: 64,
    iconWidth: 32,
    iconHeight: 32,
  }),
];

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.facet.accentBlue20,
  },
  ...buildRootSizeStyles(SIZES, (size) => {
    return {
      width: size.rootWidth,
      height: size.rootHeight,
    };
  }),
  icon: {},
  ...buildSizeStyles(SIZES, 'icon', (size) => {
    return {
      width: size.iconWidth,
      height: size.iconHeight,
    };
  }),
});

const StepAvatar = ({
  className,
  classes,
  size,
  step,
}) => {
  if (!step) return null;

  const {
    fill,
    stroke,
    IconComponent,
  } = step;

  return (
    <Avatar
      className={classNames(classes.root, className, matchRootSize(classes, SIZES, size))}
      size={size}
    >
      <Icon
        className={classNames(classes.icon, matchSize(classes, SIZES, 'icon', size))}
        fill={fill}
        icon={IconComponent}
        stroke={stroke}
      />
    </Avatar>
  );
};

StepAvatar.defaultProps = {
  className: '',
};

StepAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  step: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['md', 'lg']).isRequired,
};

export default withStyles(styles)(StepAvatar);
